import { TWithdrawalTransactionStatus } from 'models/transaction'
import { EWithdrawalRequestStatus, EWithdrawalSubmissionSource } from 'models/withdrawalRequest'

export const withdrawalRequestStatusLabels: Record<EWithdrawalRequestStatus, string> = {
  [EWithdrawalRequestStatus.OPEN]: 'Формируется',
  [EWithdrawalRequestStatus.PENDING]: 'Ожидает вывода',
  [EWithdrawalRequestStatus.APPROVED]: 'Одобрено',
  [EWithdrawalRequestStatus.REJECTED]: 'Отклонено',
  [EWithdrawalRequestStatus.COMPLETED]: 'Выведено'
}

export const withdrawalRequestStatusColors: Record<EWithdrawalRequestStatus, string> = {
  [EWithdrawalRequestStatus.OPEN]: 'gold',
  [EWithdrawalRequestStatus.PENDING]: 'blue',
  [EWithdrawalRequestStatus.APPROVED]: 'blue',
  [EWithdrawalRequestStatus.REJECTED]: 'red',
  [EWithdrawalRequestStatus.COMPLETED]: 'green'
}

export const withdrawalSubmissionSourceLabels: Record<EWithdrawalSubmissionSource, string> = {
  [EWithdrawalSubmissionSource.AUTO]: 'Автоматически',
  [EWithdrawalSubmissionSource.MANUAL]: 'Вручную'
}

export const withdrawalTransactionStatusColors: Partial<Record<TWithdrawalTransactionStatus, string>> = {
  'Принят': 'orange',
  'Готов к выводу': 'green',
  'Заявка на вывод': 'purple',
  'Ожидает вывода': 'blue',
  'Ожидает 7 дней': 'gold',
  'Выведено': 'green',
  'Заказ был отменён': 'red',
  'Заказ был отменен': 'red'
}

// Бэкенд хранит статус транзакции как русскую строку — отображаемые названия меняем здесь
export const withdrawalTransactionStatusLabels: Partial<Record<TWithdrawalTransactionStatus, string>> = {
  'Ожидается доставка до покупателя': 'В доставке',
  'Заказ был отменён': 'Заказ отменён',
  'Заказ был отменен': 'Заказ отменён'
}

export const getWithdrawalRequestStatusLabel = (status: string) => {
  return withdrawalRequestStatusLabels[status as EWithdrawalRequestStatus] ?? status
}

export const getWithdrawalRequestStatusColor = (status: string) => {
  return withdrawalRequestStatusColors[status as EWithdrawalRequestStatus] ?? 'default'
}

export const getWithdrawalTransactionStatusColor = (status?: string | null) => {
  return withdrawalTransactionStatusColors[status as TWithdrawalTransactionStatus] ?? 'default'
}

export const getWithdrawalTransactionStatusLabel = (status: string) => {
  return withdrawalTransactionStatusLabels[status as TWithdrawalTransactionStatus] ?? status
}

// requestStatuses — что уходит на бэкенд: статус отмены хранится в базе в двух написаниях («ё» и «е»)
export const withdrawalTransactionStatusFilterOptions: Array<{
  value: TWithdrawalTransactionStatus
  requestStatuses: TWithdrawalTransactionStatus[]
}> = [
  { value: 'Принят', requestStatuses: ['Принят'] },
  { value: 'Ожидается доставка до покупателя', requestStatuses: ['Ожидается доставка до покупателя'] },
  { value: 'Ожидает 7 дней', requestStatuses: ['Ожидает 7 дней'] },
  { value: 'Готов к выводу', requestStatuses: ['Готов к выводу'] },
  { value: 'Заявка на вывод', requestStatuses: ['Заявка на вывод'] },
  { value: 'Ожидает вывода', requestStatuses: ['Ожидает вывода'] },
  { value: 'Выведено', requestStatuses: ['Выведено'] },
  { value: 'Заказ был отменён', requestStatuses: ['Заказ был отменён', 'Заказ был отменен'] }
]
